export const infoFlowProject = 'infoFlowProject';
